<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header mb-2">
        <div class="form-group row mb-2"> 
        <span><b>PROYECTO:</b>{{descripcionProyecto}}</span>  
        </div>
      </div>

      <div class="container card-body table-responsive">
        <div class="row mb-2" *hasDenied="{nivel:idSprNivel, app: constant.PROYECTOS}">
          <div class="col-sm-6 text-sm-right">
        <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalEtapa()"><i class="fas fa-plus fa-lg mr-1"></i>Nuevo</button>
          </div>
        </div>
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th class="etapa-column">Etapa</th>
              <th>Hitos requeridos</th>
              <th>Peso total</th>
              <th>Hito</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dataEtapaProyecto;let indice=index">
              <td>{{indice+1}}</td>
              <td>{{row.nombre}}</td>
              <td>{{row.maximoHitos}}</td>
              <td>{{row.pesoTotal}} %</td>     
              <td class="text-center">
                <div class="row">
                  <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill px-0" title="Agregar hito" (click)="hitoInit(row)">
                    <i class="fas fa-tasks fa-lg"></i>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.PROYECTOS}">
                  <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="update(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(row.idSprEtapa)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<jw-modal id="borrar-etapa" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<jw-modal id="{{nameModalEtapa}}">

  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameEtapa}}</h3>
        <button type="button" class="btn-close" (click)="modal.closeId(nameModalEtapa);" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5">
        <form action="#" [formGroup]="formEtapa" class="needs-validation">
          <input type="hidden" id="idSprEtapa" formControlName="idSprEtapa">
          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprEtapaProyecto" class=" form-control-label text-md-right pt-1"><b>Etapas de proyecto:</b></label>
            </div>

            <div class="col-12 col-md-4">
              <select class="form-select col-12" formControlName="idSprEtapaProyecto" required="true" (change)="onSelectEtapa(dataCatalogoEtapaProyecto)" [ngClass]="{'is-invalid': this.formEtapa.get('idSprEtapaProyecto')?.errors && this.formSubmitted, 'is-valid': !this.formEtapa.get('idSprEtapaProyecto')?.errors,}"> 
                <option *ngFor=" let  etapa of dataCatalogoEtapaProyecto" value={{etapa.idSprEspecialUno}}>
                  {{etapa.nombre}}
                </option>
              </select>
              <div class="col text-danger">
                <small class="font-italic" *ngIf="this.formEtapa.get('idSprEtapaProyecto')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
              </div>
            </div>
            
            <div class="col col-md-2 text-md-right">
              <label for="maximoHitos" class=" form-control-label text-md-right pt-1"><b>Máximo hito:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <input type="number" min="1" max="100" maxlength="3" onkeydown="return false" name="maximoHitos id=" maximoHitos placeholder="Solo caracteres Numericos" class="form-control" required="true" autocomplete="off" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="maximoHitos" required autofocus placeholder="Máximo hitos" [ngClass]="{'is-invalid':this.formEtapa.get('maximoHitos')?.errors && this.formSubmitted,'is-valid': this.formEtapa.value.maximoHitos}">
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formEtapa.get('maximoHitos')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="pesoTotal" class=" form-control-label text-md-right pt-1">Peso total:</label>
            </div>
            <div class="col-12 col-md-4">
              <input class="form-control" style="background-color: #f5f4f4;" autocomplete="off" readonly="readonly" required="true" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="pesoTotal" placeholder="Porcentaje">
            </div>
            <div class="col col-md-2 text-xl-right">
              <label for="estado" class=" form-control-label text-md-right pt-1"><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formEtapa.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formEtapa.get('estado')?.errors,}">
                <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formEtapa.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>    
        </form>
      </div> 
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect"
          (click)="modal.closeId(nameModalEtapa);">Cerrar</button>
        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>

<jw-modal id="{{editNameModalEtapa}}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameEtapa}}</h3>
        <button type="button" class="btn-close" (click)="modal.closeId(editNameModalEtapa);" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5">
        <form action="#" [formGroup]="formEtapa" class="needs-validation">
          <input type="hidden" id="idSprEtapa" formControlName="idSprEtapa">
          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprEtapaProyecto" class=" form-control-label text-md-right pt-1"><b>Etapas de proyecto:</b></label>
            </div>
            <div class="col-12 col-md-4"readonly="readonly">
              <span class="form-control" style="background-color: #f5f4f4;" autocomplete="off" readonly="readonly">{{titulosEtapa[0].nombre}}</span>
            </div>
            <div class="col col-md-2 text-md-right">
              <label for="maximoHitos" class=" form-control-label text-md-right pt-1"><b>Máximo hito:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <input type="number" min="1" max="100 " maxlength="3" onkeydown="return false" name="maximoHitos id=" maximoHitos placeholder="Solo caracteres Numericos" class="form-control" required autocomplete="off" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="maximoHitos" required
                autofocus placeholder="Máximo hitos" [ngClass]="{'is-invalid':this.formEtapa.get('maximoHitos')?.errors && this.formSubmitted,'is-valid': this.formEtapa.value.maximoHitos}">
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formEtapa.get('maximoHitos')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="pesoTotal" class=" form-control-label text-md-right pt-1">Peso total:</label>
            </div>
            <div class="col-12 col-md-4">
              <input class="form-control" style="background-color: #f5f4f4;" autocomplete="off" readonly="readonly" required="true" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="pesoTotal" placeholder="Porcentaje">
            </div>

            <div class="col col-md-2 text-xl-right">
              <label for="estado" class=" form-control-label text-md-right pt-1"><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-4">
              <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formEtapa.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formEtapa.get('estado')?.errors,}">
                <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                </option>
              </select>
              <div class="col text-danger">
                <span class="font-italic" *ngIf="this.formEtapa.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
              </div>
            </div>
          </div>     
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId(editNameModalEtapa);">Cerrar</button>
        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>

<!-- Inicio modal detalle proyeto -->
<jw-modal id="{{nameModal1}}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:5%; max-width: 75%; max-height: 90%;">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{ nameModal1 }}</h3>
        <button type="button" class="btn-close" (click)="modal.closeId(nameModal1);" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="hito" role="tabpanel" aria-labelledby="hito-tab">
            <app-hito [data]="hito" [proyecto]="proyectoInput"></app-hito>
          </div>
        </div>
      </div>
    </div>
  </div>
</jw-modal>